import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Template from '../Components/Template';
import useDataTable from '../Hooks/useDataTable';
import { useDeleteExamFormMutation, useGetAllExamFormsForAdminsMutation, useGetSubAgentsByAgentQuery,useGetAllExamFormsForAdminsFilterMutation, useGetTotalAmountAgentQuery, useGetSchoolsAgentWiseQuery, useGetAllExamFormsForAdminFilterMutation, useGetAllExamFormsOfAgentsForAdminFilterMutation, useGetCashDepositRecordsQuery, useGetAllExamSchoolsMutation, useCreateExamSchoolMutation, useDeleteExamSchoolMutation, useGetAllExamSchoolsQuery } from '../Services/modules/exam';
import { MdOutlineNavigateNext, MdSkipNext, MdSkipPrevious, MdEdit, MdDelete } from "react-icons/md";
import { GrFormPrevious } from "react-icons/gr";
import WarningModal from '../Components/WarningModal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Config } from '../Config';
import { formatDateInput } from '../util/formatDate';
import { useLocation, useParams } from 'react-router-dom';
import { useDebounce } from '../util/useSearchSchool';

function ExamSchools() {
//     const location = useLocation();
//   const searchParams = new URLSearchParams(location.search);
//   const agentId = searchParams.get('agentId');
 //const { agentId, agentName } = useParams();
//console.log("agentId",agentId)
    const userData = useSelector((state) => state.userData.user_data);
   // console.log("Userdata", userData);
   
    let token=userData.token
    const {   
        handleFirstPage,
        handlePageSizeChange,
        handleLastPage,
        sequenceStartIndex,
        page,
        rowsPerPage,
        totalRows,
        setTotalRows,
        setPage,
        setTotalPages,
        totalPages
    } = useDataTable();

    const [examSchools, setExamSchools] = useState([]);
    const [subAgents, setSubagents] = useState([]);
    const [schoolsAgentWise, setSchoolsAgentWise] = useState([]);
     
    const[total_amount,setTotalAmount]=useState("")
    const [subAgentValue, setSubAgentValue] = useState("");
    const [schoolNameValue, setSchoolNameValue] = useState("");

    const [examNameValue, setExamNameValue] = useState("");
    const [examStandardValue, setExamStandardValue] = useState("");
    const[enrollmentDate,setEnrollmentDate]=useState("")
    const [schoolName, setSchoolName] = useState("");
   // const [schoolId, setSchoolId] = useState("");
    

    const [exam_medium, setExamMedium] = useState("");

    
    const[schoolId,setSchoolId]=useState("")
    const[schoolIdForDelete,setSchoolIdForDelete]=useState("")
    const[isDelete,setIsDelete]=useState(false) 
       const[isDeleteModal,setDeleteModal]=useState(false)
       const [isSumbmiting,setIsSubmitting]=useState(false)
    const [searchTerm, setSearchTerm] = useState("");

  const debouncedSearch = useDebounce(searchTerm, 500);
     
 // const [GetAllExamSchools, { data, isSuccess, isLoading, isError, error }] = useGetAllExamSchoolsMutation();
    const { data:examSchoolsData, isSuccess:examSchoolsGetDataSuccess, isLoading:examSchoolsGetDataIsLoading, error:examSchoolsError,refetch } = useGetAllExamSchoolsQuery(
      {
        page_number: page,
    page_size: rowsPerPage,
    search: debouncedSearch

      });

const [showPreview, setShowPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState(null);

    //const { data:depositData, isSuccess:depositSuccess, isLoading:depositIsLoading, error:depositError } = useGetCashDepositRecordsQuery({agentId});
   
  //const { data: dataSchools, isSuccess: isSuccessSchools, isLoading: isLoadingSchools, error: errorSchools, refetch: refetchSchools } = useGetSchoolsAgentWiseQuery();

  
  const [CreateExamSchool, { data:examSchoolData, isSuccess:examSchoolSuccess, isLoading:examSchoolLoading, isError:examSchoolIsError, error:examSchoolError }] = useCreateExamSchoolMutation();


    const [DeleteExamSchool, { 
        data:deleteData=[], 
        isSuccess:deleteIsSuccess, 
        isLoading:deleteIsLoading, 
        isError:deleteIsError, 
        error:deleteError }] = useDeleteExamSchoolMutation();

    // useEffect(() => {
    //     if (isSuccess) {
    //         console.log("Exam schools", data);
    //         setExamSchools(data.data);
    //         setTotalRows(data.totalRows)           

    //     }
    // }, [data]);
    
 useEffect(() => {
        if (examSchoolsGetDataSuccess) {
            console.log("Exam schools", examSchoolsData);
            setExamSchools(examSchoolsData.data);
            setTotalRows(examSchoolsData.totalRows)           

        }
    }, [examSchoolsData]);

    const handleDelete=(dataRow)=>{
        setDeleteModal(true)
        setSchoolIdForDelete(dataRow._id)
      }
      useEffect(() => {
        if(isDelete)
        {
          DeleteExamSchool({schoolIdForDelete})
        }
      
      }, [isDelete]);
      useEffect(()=>{
    
        if(deleteIsSuccess)
        {
          console.log("deleteddataProduct",deleteData)
    
          if(!deleteData.error)
          {
            // setProducts(deleteData.data)
            // setTotalRows(deleteData.totalRows)
            toast.success(deleteData.message)
            setIsDelete(false)
            setDeleteModal(false)
             setSchoolIdForDelete('')
    
    
    //refetch()
            
          }
          else
          {
            toast.error(deleteData.message)
            setIsDelete(false)
            setDeleteModal(false)
            setSchoolIdForDelete('')
    
          }
        
        }
          },[deleteData])

          useEffect(() => {
               refetch();
             }, [page, rowsPerPage, debouncedSearch]);

  //           useEffect(() => {
  //   GetAllExamSchools({
  //     page_number: page,
  //     page_size: rowsPerPage,
  //     search: debouncedSearch, 
  //   });
  // }, [page, rowsPerPage, debouncedSearch]);

          useEffect(() => {
    setPage(0);
  }, [debouncedSearch]);
useEffect(()=>{
    if(examSchoolSuccess)
    {
        console.log("examSchoolData",examSchoolData)
        toast.success(examSchoolData.message)
        setIsSubmitting(false)
    }
},[examSchoolData])

      const saveNewSchool=()=>{
          setIsSubmitting(true)
        CreateExamSchool({schoolId,schoolName})
      }
       
    const ExamSchoolsScreen = () => {
        return (
            <>
            {showPreview && (
  <div className="modal show d-block" tabIndex="-1" role="dialog" onClick={() => setShowPreview(false)}>
    <div className="modal-dialog modal-lg" role="document" onClick={e => e.stopPropagation()}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Proof Preview</h5>
          <button type="button" className="btn-close" onClick={() => setShowPreview(false)}></button>
        </div>
        <div className="modal-body text-center">
          {previewFile.endsWith('.pdf') ? (
            <iframe src={previewFile} title="PDF Preview" width="100%" height="500px"></iframe>
          ) : (
            <img src={previewFile} alt="Preview" style={{ maxWidth: '100%', maxHeight: '500px' }} />
          )}
        </div>
      </div>
    </div>
  </div>
)}
             <
                WarningModal
                setShowWarningModal={setDeleteModal}
                modalTitle={"Delete Product"}
                setIsDelete={setIsDelete}
                showModal={isDeleteModal}
              />
              <ToastContainer/>
                <main id="main" class="main">
                    <div className='container'>
                        <div className="row">
          <h3 className="text-center mb-4">Report of Schools</h3>
        </div>
                        <div className='card'>
                            <div className='card-body'>
                                {/* Total Collection: {total_amount} */}
                               
                              
                                <div className='row'  style={{ margin: "20px" }}>                                    
                                     <div className='col-md-3'>
    <input
      type="text"
      className="form-control mb-3"
      placeholder="School Name"
      value={schoolName}
      onChange={(e) => setSchoolName(e.target.value)}
      //maxLength={10}
    />
  </div>
  <div className='col-md-3'>
    <input
      type="text"
      className="form-control mb-3"
      placeholder="School Id"
      value={schoolId}
      onChange={(e) => setSchoolId(e.target.value)}
      maxLength={10}
    />
  </div>
                                    <div className='col-md-3'>
                                          <button type="submit" 
                className="btn btn-primary"              
                onClick={()=>saveNewSchool()}
                >
                   {isSumbmiting ? 
                  'Submitting...' :                  
                  'Submit'} 
                 
                </button>
                                        {/* <button className='btn btn-primary' onClick={() => saveNewSchool()}>Save School</button> */}
                                    </div>
                                   
                                </div>

                                <div className="row" style={{ margin: "20px" }}>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by name, year or ID..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  </div>
                               
                                <table className="bordered-table">
                                    <thead>
                                        <tr>
                                        <th>Action</th>                                         
                                            <th>Index</th>
                                             <th>School Id</th>
                                            <th>School Name</th>
                                            <th>Added Date</th>                                          
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {examSchools.map((item, index) => (
                                            <tr key={index}>

                                                 <td>
                
              <MdDelete onClick={()=>handleDelete(item)} style={{cursor:'pointer'}}/>
              </td>
              
                                                <td>{sequenceStartIndex + index}</td>
                                                 <td>{item.school_id}</td>
                                                <td>
                                                    {item.school_name}
                                                </td>
                                               
                                                <td>
                                                    {item?.createdDate+" "+item?.createdTime}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
      <button onClick={() => handleFirstPage()} disabled={page === 0}><MdSkipPrevious/></button> 

                                <button onClick={() => setPage(page - 1)} disabled={page === 0}><GrFormPrevious /></button>
                                <button onClick={() => setPage(page + 1)} disabled={page === totalPages - 1}><MdOutlineNavigateNext /></button>
       <button onClick={() => handleLastPage()} disabled={page === totalPages - 1}><MdSkipNext/></button> 

                                <div>
                                    <select value={rowsPerPage} onChange={handlePageSizeChange}>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                    </div>
                </main>
            </>
        );
    };

    return (
        <Template>{ExamSchoolsScreen()}</Template>
    );
}

export default ExamSchools;